export * from './module';

export * from './feature-details';
export * from './feature-list';
export * from './feature-item';
export * from './shared';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/feature/index.ts